module.exports = __webpack_public_path__ + "static/media/tpp_link_default.4df7f196.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tpp_link_default.svg
// module id = 744
// module chunks = 21